<template>
  <div id="philosophy" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>経営理念</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">会社案内</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="company-layout">
        <CompanyNav active-key="philosophy" />

        <div class="page-card">
          <p class="page-kicker">Philosophy</p>
          <h2>InnoSourceが大切にすること</h2>
          <ul class="timeline-list">
            <li>
              <strong>初心忘れるべからず</strong><br>
              常に謙虚な気持ちを忘れることなく、チャレンジャーとして挑戦していきます。<br>
              「一番良い」ではなく「より良い」製品、サービスを提供し続けることに取り組んでいきます。
            </li>
            <li>
              <strong>社員を大切に</strong><br>
              最前線でお客様と接している社員を支え、能力を発揮するために必要な権限とサポートを与えこと重点に考えています。<br>
              また、社員が豊かな生活を実現できるように環境整備します。<br>
              これらの実現することが「より良いサービス」を長くお客様に提供できることに繋がるはずです。
            </li>
            <li>
              <strong>より良い会社、社会へ</strong><br>
              企業活動を通じて豊かな社会づくりに貢献し、社会とともに成長していく企業であり続けるように努めていきます。
            </li>
          </ul>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';
import CompanyNav from '@/components/companyNav';

export default {
  name: 'philosophy',
  components: {
    Top,
    Foot,
    CompanyNav,
  },
};
</script>
